import { createTheme } from '@mui/material/styles';
import { brandColors } from './colors';
import { typography } from './typography';
/**
 * Material-UI Theme Configuration for Horwath HTL
 */
export const horwathTheme = createTheme({
    palette: {
        primary: {
            main: brandColors.indigo,
            light: brandColors.blue,
            dark: brandColors.grayDark,
            contrastText: brandColors.white,
        },
        secondary: {
            main: brandColors.gold,
            contrastText: brandColors.indigo,
        },
        background: {
            default: brandColors.white,
            paper: brandColors.grayLight,
        },
        text: {
            primary: brandColors.indigo,
            secondary: brandColors.grayMedium,
        },
        error: {
            main: brandColors.error,
        },
        warning: {
            main: brandColors.warning,
        },
        success: {
            main: brandColors.success,
        },
        info: {
            main: brandColors.info,
        },
    },
    typography: {
        fontFamily: typography.fontFamily,
        h1: {
            fontSize: typography.fontSizes['5xl'],
            fontWeight: typography.fontWeights.light,
            lineHeight: typography.lineHeights.tight,
        },
        h2: {
            fontSize: typography.fontSizes['4xl'],
            fontWeight: typography.fontWeights.light,
            lineHeight: typography.lineHeights.tight,
        },
        h3: {
            fontSize: typography.fontSizes['3xl'],
            fontWeight: typography.fontWeights.regular,
            lineHeight: typography.lineHeights.normal,
        },
        h4: {
            fontSize: typography.fontSizes['2xl'],
            fontWeight: typography.fontWeights.regular,
            lineHeight: typography.lineHeights.normal,
        },
        h5: {
            fontSize: typography.fontSizes.xl,
            fontWeight: typography.fontWeights.bold,
            lineHeight: typography.lineHeights.normal,
        },
        h6: {
            fontSize: typography.fontSizes.lg,
            fontWeight: typography.fontWeights.bold,
            lineHeight: typography.lineHeights.normal,
        },
        body1: {
            fontSize: typography.fontSizes.base,
            lineHeight: typography.lineHeights.normal,
        },
        body2: {
            fontSize: typography.fontSizes.sm,
            lineHeight: typography.lineHeights.normal,
        },
        button: {
            fontSize: typography.fontSizes.sm,
            fontWeight: typography.fontWeights.bold,
            letterSpacing: typography.letterSpacing.wider,
            textTransform: 'uppercase',
        },
    },
    shape: {
        borderRadius: 3,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 3,
                    padding: '0.75em 1.5em',
                    transition: 'all 0.2s ease',
                },
                contained: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 3,
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                },
            },
        },
    },
});
//# sourceMappingURL=mui-theme.js.map